import { render, staticRenderFns } from "./AntibodiesPopup.vue?vue&type=template&id=d1015762&scoped=true&"
import script from "./AntibodiesPopup.vue?vue&type=script&lang=js&"
export * from "./AntibodiesPopup.vue?vue&type=script&lang=js&"
import style0 from "./AntibodiesPopup.vue?vue&type=style&index=0&id=d1015762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1015762",
  null
  
)

export default component.exports